import { Injectable } from "@angular/core";
import { ErrorApi, ErrorLogin } from "../../core/models/errorApi.model";
import Swal, { SweetAlertIcon } from 'sweetalert2'
import * as XLSX from 'xlsx';


@Injectable()
export class MessageDialog {
  public ShowAlert(message: string, title?: string) {
    Swal.fire({
      icon: "error",
      title: title ? title : "Error",
      html: message,
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-primary",
      },
      buttonsStyling: false,
    });
  }

  public ShowException(errorApi: ErrorApi | ErrorLogin, title?: string) {
    let message = "";
    if (ErrorLogin.instanceOfErrorLogin(errorApi)) {
      let error = errorApi as ErrorLogin;
      this.ShowAlert(error.error_description);
      return;
    }

    let error = errorApi as ErrorApi;
    if (error && error.ErrorDescription) {
      error.ErrorDescription.forEach((element) => {
        message = message + " " + element;
      });
      this.ShowAlert(message, title);
    }
  }

  public ShowQuestion(message: string, title: string): Promise<any> {
    return Swal.fire({
      title: title,
      text: message,
      icon: "warning",
      showCancelButton: true,
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-outline-white",
        cancelButton: "btn btn-primary",
      },
      confirmButtonText: "Sí",
      cancelButtonText: "Cancelar",
      buttonsStyling: false,
    });
  }

  public ShowMessage(message: string, titulo: string, icono: SweetAlertIcon = "success") {
    Swal.fire({
      icon: icono,
      title: titulo,
      // text: message,
      html: message,
      backdrop: true,
      buttonsStyling: false,
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-primary"
      }
    });
  }

  public ShowContinueMessage(message: string, titulo: string,): Promise<any> {
    return Swal.fire({
      icon: "success",
      title: titulo,
      text: message,
      backdrop: true,
      buttonsStyling: false,
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-primary"
      }
    });
  }

  public ShowLoading(message: string, titulo: string): Promise<any> {
    return Swal.fire({
      title: titulo,
      html: `<div><div class="spinner-border" style="width: 3em;height: 3em;margin-bottom: 1em;"><span class="sr-only">Loading...</span></div></div> ${message}`,
      backdrop: true,
      showConfirmButton: false,
      heightAuto: false,
      allowOutsideClick: false
    });
  }


  public ShowSMTPTestMessage(message: string, title: string): Promise<any> {
    return Swal.fire({
      title: title,
      text: message,
      input: 'email',
      inputPlaceholder: 'mail@mail.com',
      inputValidator: (value) => {
        // Verifica si el valor es vacío o si no cumple con el patrón de un correo electrónico.
        if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return '<i class="fa fa-info-circle"></i> Email no válido';
        }
      },
      showCancelButton: true,
      heightAuto: false,
      customClass: {
        cancelButton: "btn btn-outline-white",
        confirmButton: "btn btn-primary",
      },
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Enviar',
      buttonsStyling: false,
    });
  }

  public ShowInviteErrorsWithDownload(errorLog: any[], title: string, exportCallback: () => void) {
    let errorMessage = `<p>Se han encontrado errores en las siguientes invitaciones:</p><ul>`;

    /*  errorLog.forEach(error => {
       errorMessage += `<li>${error['Empleado']}: ${error['Error']}</li>`;
     }); */

    errorMessage += `</ul>`;

    if (errorLog.length > 0) {
      errorMessage += `
        <br/>
        <button id="downloadExcel" class="btn btn-primary">Descargar Errores en Excel</button>
      `;
    }

    errorMessage += `
      <button id="continueButton" class="btn btn-primary" style="margin-left: 10px;">Continuar</button>
    `;

    Swal.fire({
      icon: errorLog.length > 0 ? "warning" : "success",
      title: title,
      html: errorMessage,
      showCancelButton: false,
      showConfirmButton: false,
      heightAuto: false,
      customClass: {
        popup: 'swal-wide',
      },
      didRender: () => {
        const downloadButton = document.getElementById('downloadExcel');
        if (downloadButton) {
          downloadButton.addEventListener('click', exportCallback);
        }

        const continueButton = document.getElementById('continueButton');
        if (continueButton) {
          continueButton.addEventListener('click', () => Swal.close());
        }
      },
    });
  }

  public showQuestionInput(message: string, title: string, defaultValue: string = '', inputLabel: string = ''): Promise<any> {
    return Swal.fire({
      title: title,
      html: `
        <p>${message}</p>
        <div style="display: flex; justify-content: center; flex-direction: column; margin: 2em 0;">
          <label for="swal-textarea" style="margin: 0; font-weight: bold; color: dimgray; font-size: 1em;">${inputLabel}</label>
          <textarea 
            id="swal-textarea" 
            class="swal2-textarea" 
            style="font-size: 0.9em; margin: 0; resize: none; overflow-y: auto; height: auto; max-height: 6em;" 
            rows="2" 
            maxlength="300">${defaultValue}</textarea>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-white"
      },
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      buttonsStyling: false,
      preConfirm: () => {
        const inputValue = (document.getElementById('swal-textarea') as HTMLTextAreaElement).value;
        return inputValue;
      }
    });
  }

  public ShowInfoHTML(message: string, title: string, onlyConfirmClose: boolean = false): Promise<any> {
    return Swal.fire({
      title: title,
      html: `${message}`,
      icon: "info",
      showCancelButton: false,
      heightAuto: false,
      allowOutsideClick: !onlyConfirmClose,
      customClass: {
        confirmButton: "btn btn-primary"
      },
      confirmButtonText: "Continuar",
      buttonsStyling: false,
    });
  }

  public ShowQuestionHTML(message: string, title: string): Promise<any> {
    return Swal.fire({
      title: title,
      html: `${message}`,
      icon: "question",
      showCancelButton: true,
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-outline-white",
        cancelButton: "btn btn-primary",
      },
      confirmButtonText: "Sí",
      cancelButtonText: "Cancelar",
      buttonsStyling: false,
    });
  }

}
